import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { DASHBOARD_TEACHER } from '../constants/actionTypes'
import * as API from '../constants/api'

export const dashboardTeacher = createAsyncThunk(
  DASHBOARD_TEACHER,
  async (params: PayloadCreatorParams<`${typeof API.DASHBOARD_TEACHER}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.dashboardTeacher(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const dashboardTeacherClear = createAction(`${DASHBOARD_TEACHER}/clear`)
